document.documentElement.classList.remove('no-js');
document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    nav?.toggleAttribute('data-open', !open);
  });
});

document.querySelectorAll('[data-motion-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const video = button.closest('.motion-card')?.querySelector('video');
    if (!video) return;
    if (video.paused) { video.play(); button.textContent = 'Pause'; }
    else { video.pause(); button.textContent = 'Play'; }
  });
});
